import React from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Jurisdictions from "@/components/site/Jurisdictions";
import Practice from "@/components/site/Practice";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Careers from "@/components/site/Careers";
import Contact from "@/components/site/Contact";
import DisclaimerModal from "@/components/site/DisclaimerModal";
import useSeo from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "Sikdar & Sikdar, Advocates — Litigation & Advisory, Chennai",
    description:
      "Sikdar & Sikdar, Advocates — a boutique litigation and advisory chamber in Chennai. Founded by M.K. Sikdar (27+ years at the Bar). Civil, commercial, constitutional, property, family, service, consumer and regulatory law.",
    canonical: "https://sikdaradvocates.com/",
  });

  return (
    <div data-testid="home-page">
      <DisclaimerModal />
      <Header />
      <main>
        <Hero />
        <About />
        <Practice />
        <Jurisdictions />
        <WhyChooseUs />
        <Careers />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
